import { Access } from 'hooks/data/files/types';
import { ReleaseVersionMap } from 'hooks/data/versions/types';

export const checkAccessToResource = (access: Access | undefined, resourceKey: string, ver: string): boolean =>
  access?.[ver]?.includes(resourceKey) ?? false;

export const checkAccessToV4 = (versions: ReleaseVersionMap | undefined): boolean => {
  if (!versions) return false;

  const version4 = Object.values(versions).some((versionArray) =>
    versionArray.some((versionObj) => versionObj.version.startsWith('ei25'))
  );
  return !!version4;
};
